import { ReducerCreators, PayloadAction } from '@reduxjs/toolkit';
import { AudiencesState } from '../types';

export const setShowAddPasscodeListModal = (create: ReducerCreators<AudiencesState>) =>
  create.reducer((state, action: PayloadAction<boolean>) => {
    state.showAddPasscodeListModal = action.payload;
  });
